import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { initGA } from './utils/analytics';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Destinations from './pages/Destinations';
import DestinationDetail from './pages/DestinationDetail';
import ThankYou from './pages/ThankYou';
import FAQ from './pages/FAQ';
import Resources from './pages/Resources';
import WeddingCostCalculator from './pages/WeddingCostCalculator';
import GuestExperienceCalculator from './pages/GuestExperienceCalculator';
import PlanningGuides from './pages/resources/guides';
import TopVenues from './pages/resources/top-venues';
import Footer from './components/Footer';
import './App.css';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // This will run on every route change
    // ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <AnalyticsTracker />
        <ScrollToTop />
        <div className="min-h-screen bg-white">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact/thank-you" element={<ThankYou />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/guides" element={<PlanningGuides />} />
            <Route path="/resources/guides/top-venues" element={<TopVenues />} />
            <Route path="/wedding-cost-calculator" element={<WeddingCostCalculator />} />
            <Route path="/resources/guest-experience-calculator" element={<GuestExperienceCalculator />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
